/* unplugin-vue-components disabled */import { render } from "./TokensFalling.vue?vue&type=template&id=0580d0dc&scoped=true"
import script from "./TokensFalling.vue?vue&type=script&lang=js"
export * from "./TokensFalling.vue?vue&type=script&lang=js"

import "./TokensFalling.vue?vue&type=style&index=0&id=0580d0dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0580d0dc"]])

export default __exports__